<template>
  <DrawerHeader @close="emit('cancel')"
    >Configure Split</DrawerHeader
  >
  <div class="flex flex-col space-y-3 p-4">
    <div
      class="my-4 flex w-full items-center justify-center space-x-4"
    >
      <button
        :disabled="decrementEqualSplitPartitionDisabled"
        class="flex items-center justify-center rounded-full border border-background-fg/20 p-2"
        @click="decrementEqualSplitPartition"
      >
        <IconMinus />
      </button>
      <div class="min-w-10 text-center text-4xl font-bold">
        {{ equalSplitPartition }}
      </div>
      <button
        class="flex items-center justify-center rounded-full border border-background-fg/20 p-2"
        @click="incrementEqualSplitPartition"
      >
        <IconPlus />
      </button>
    </div>
    <ActionButtonPrimary
      class="self-stretch"
      @click="emit('submit', equalSplitPartition)"
    >
      Split {{ equalSplitPartition }} ways
    </ActionButtonPrimary>
    <ActionButtonSecondary
      class="self-stretch"
      @click="emit('submit', 'manual')"
    >
      Split manually
    </ActionButtonSecondary>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  (event: "submit", splitMethod: number | "manual"): void
  (event: "cancel"): void
}>()

const equalSplitPartition = ref(2)

const incrementEqualSplitPartition = () => {
  equalSplitPartition.value += 1
}

const decrementEqualSplitPartitionDisabled = computed(
  () => equalSplitPartition.value <= 2
)
const decrementEqualSplitPartition = () => {
  if (!decrementEqualSplitPartitionDisabled.value) {
    equalSplitPartition.value -= 1
  }
}
</script>
